import { ModalErrorTextualConfig } from '@core/interfaces/modal-error-config.interface';
import { PROJECT_TYPE } from '@core/types/projects.type';

export const BRIDGER_INSIGHT_CONFIG = new Map<PROJECT_TYPE, ModalErrorTextualConfig>([
  [
    'ACC',
    {
      imageUrl: {
        url: 'assets/img/errors/error__info-not-loaded.svg',
        altUrl: 'Information not loaded icon/illustration',
      },
      errorTitle: '¡Lo sentimos!',
      errorDescription: 'No puede acceder a una cuenta por este medio, acércate a una agencia.',
      errorDescriptionComplement:
        'Para continuar con la apertura de tu nueva cuenta, acércate a una agencia. Ubica la más cercana en',
      errorDescriptionUrl: 'www.pichincha.pe',
      buttonLabel: 'Entendido',
    },
  ],
  [
    'PLD',
    {
      imageUrl: {
        url: 'assets/img/errors/error__info-not-loaded.svg',
        altUrl: 'Information not loaded icon/illustration',
      },
      errorTitle: '¡Aún no cuentas con un préstamo preaprobado!',
      errorDescription:
        'Pero tranquilo, visita la agencia más cercana para conocer si tenemos un producto disponible para ti.',
      errorDescriptionComplement:
        'Para continuar con la solicitud de tu préstamo, acércate a una agencia. Ubica la más cercana en',
      errorDescriptionUrl: 'www.pichincha.pe',
      buttonLabel: 'Entendido',
    },
  ],
  [
    'FTD',
    {
      imageUrl: {
        url: 'assets/img/errors/error__info-not-loaded.svg',
        altUrl: 'Information not loaded icon/illustration',
      },
      errorTitle: '¡Lo sentimos!',
      errorDescription: 'En estos momentos no podemos atenderte por este medio.',
      errorDescriptionComplement:
        'Para continuar con la apertura de tu depósito a plazo fijo, acércate a una agencia. Ubica la más cercana en',
      errorDescriptionUrl: 'www.pichincha.pe',
      buttonLabel: 'Entendido',
    },
  ],
]);
